import { getTrackingKey } from '@/utils/api'

import API from './base'

class Repayment extends API {
  getKnetPaymentStatus = (data) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'knet_get-payment-status'),
      path: this.uri + '/knet/get-payment-status',
      data,
    })
  }
}

export default new Repayment('/repayment')
